module.exports = __webpack_public_path__ + "img/user-theme-bg.89e189a2.png";